import React from "react";
import { multilanguage } from "redux-multilanguage";
import useLinkTarget from "../../../hooks/useLinkTarget";
import ConnectedProduct from "./ConnectedProduct";
import { constructLinkNode } from "../../../utils/links";
import { LINK_TARGETS } from "../../../utils/constants/linkTargets";

// Wrapper component for the ProductTeaser
// Real Magnolia component used in the Grid
// Preloads the product picked in the dialog, allows for overrides
const ProductTeaserWrapper = ({ currentLanguageCode, productId, title, text, image }) => {
    const link = constructLinkNode({ field: LINK_TARGETS.ECOMMERCE_PRODUCTS, value: productId });
    const { target } = useLinkTarget(link, { lang: currentLanguageCode });

    const product = {
        ...target,
        ...(title && { displayName: title }),
        ...(text && { shortDescription: text }),
        ...(image && { image: [image].concat(target.image) }),
    };

    // The target is {} until the product has been fetched (or when it could not be).
    if (!Object.keys(target).length) return null;

    return <ConnectedProduct product={product} itemId={target.id ?? productId} />;
};

export default multilanguage(ProductTeaserWrapper);
